{
	"name": "studiocast-creative-admin",
	"private": true,
	"version": "1.15.0",
	"type": "module",
	"scripts": {
		"dev": "vite",
		"build": "NODE_OPTIONS='--max-old-space-size=4096' vite build",
		"build-staging": "vite build --mode staging",
		"production": "vite --mode production",
		"lint": "eslint src --ext ts,tsx --report-unused-disable-directives --max-warnings 0",
		"preview": "vite preview",
		"host": "vite --host",
		"optimize": "vite optimize"
	},
	"dependencies": {
		"@aws-sdk/client-ivs": "^3.379.1",
		"@aws-sdk/client-ivs-realtime": "^3.341.0",
		"@emotion/react": "^11.11.0",
		"@hookform/resolvers": "^5.2.2",
		"@jwplayer/jwplayer-react": "^2.0.0",
		"@mantine/carousel": "^9.2.0",
		"@mantine/core": "^9.2.0",
		"@mantine/dates": "^9.2.0",
		"@mantine/dropzone": "^9.2.0",
		"@mantine/form": "^9.2.0",
		"@mantine/hooks": "^9.2.0",
		"@mantine/modals": "^9.2.0",
		"@mantine/notifications": "^9.2.0",
		"@mantine/tiptap": "^9.2.0",
		"@rollup/plugin-node-resolve": "^16.0.3",
		"@rollup/plugin-typescript": "^12.3.0",
		"@tabler/icons-react": "^3.44.0",
		"@tanstack/react-query": "^5.100.10",
		"@tiptap/extension-highlight": "^3.23.4",
		"@tiptap/extension-link": "^3.23.4",
		"@tiptap/extension-subscript": "^3.23.4",
		"@tiptap/extension-superscript": "^3.23.4",
		"@tiptap/extension-text-align": "^3.23.4",
		"@tiptap/extension-underline": "^3.23.4",
		"@tiptap/pm": "^3.23.4",
		"@tiptap/react": "^3.23.4",
		"@tiptap/starter-kit": "^3.23.4",
		"@types/node": "^25.7.0",
		"@types/react": "^19.2.14",
		"@types/react-dom": "^19.2.3",
		"@vitejs/plugin-react": "^6.0.1",
		"amazon-ivs-chat-messaging": "^1.1.1",
		"amazon-ivs-player": "^1.18.0",
		"amazon-ivs-web-broadcast": "^1.5.2",
		"apexcharts": "^5.11.0",
		"aws-sdk": "^2.1386.0",
		"axios": "^1.16.1",
		"browserify": "^17.0.0",
		"calendar-link": "^2.4.0",
		"dayjs": "^1.11.7",
		"dompurify": "^3.4.3",
		"embla-carousel-react": "^8.6.0",
		"html-to-formatted-text": "^2.7.0",
		"i18next": "^26.1.0",
		"i18next-browser-languagedetector": "^8.2.1",
		"javascript-time-ago": "^2.5.9",
		"jwt-decode": "^4.0.0",
		"mantine-form-zod-resolver": "^1.3.0",
		"papaparse": "^5.4.1",
		"react": "^19.2.6",
		"react-apexcharts": "^2.1.0",
		"react-csv": "^2.2.2",
		"react-dom": "^19.2.6",
		"react-easy-crop": "^5.0.0",
		"react-error-boundary": "^6.1.1",
		"react-helmet-async": "^3.0.0",
		"react-hook-form": "^7.76.0",
		"react-i18next": "^17.0.7",
		"react-password-checklist": "^1.4.3",
		"react-query": "^3.39.3",
		"react-query-auth": "^2.4.3",
		"react-router-dom": "^7.15.0",
		"react-router-navigation-prompt": "^1.9.6",
		"react-time-ago": "^7.2.1",
		"react-timer-hook": "^4.0.5",
		"rollup-plugin-node-builtins": "^2.1.2",
		"typescript": "^6.0.3",
		"use-debounce": "^10.1.1",
		"uuidv4": "^6.2.13",
		"vite": "^8.0.12",
		"vite-plugin-node-polyfills": "^0.26.0",
		"vite-plugin-wasm": "^3.2.2",
		"zod": "^4.4.3"
	}
}
